The input parameter for the `replayWebhookSubscription` mutation.
